angular.module('FlexyBeautyApp.services')
    .factory('OptInOutResource', ["$resource", "$location", function ($resource, $location) {
        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + 'rest/v2/customers/:customerId/opt-in-out', {}, {
            create: {method: 'POST'},
            update: {method: 'PUT'}
        });
    }
    ]);

angular.module('FlexyBeautyApp.services')
    .factory('OptInOutService', ["$log", "OptInOutResource", "Brand", function ($log, OptInOutResource, Brand) {
        let getObjectResource = function (optInOut) {
            let optInOutRes = new OptInOutResource();

            optInOutRes.isSmsCampaignAllowed = optInOut.isSmsCampaignAllowed || false;
            optInOutRes.isNotificationCampaignAllowed = optInOut.isNotificationCampaignAllowed || false;
            optInOutRes.isEmailCampaignAllowed = optInOut.isEmailCampaignAllowed || false;
            optInOutRes.isExternalOptInOut = optInOut.isExternalOptInOut || false;
            optInOutRes.origin = "Site Internet " + Brand.label;
            optInOutRes.consentDate = optInOut.consentDate || new Date();

            return optInOutRes;
        };

        let service = {};

        /* get a single optInOut with params = { customerId, id } */
        service.get = function (params) {
            return OptInOutResource.get({customerId: params.customerId}).$promise;
        };

        /* create a new optInOut with params = { customerId, optInOut } */
        service.create = function (params) {
            let optInOutRes = getObjectResource(params.optInOut);
            return optInOutRes.$create({customerId: params.customerId});
        };

        /* update existing optInOut with params = { customerId, optInOut } */
        service.update = function (params) {
            let optInOutRes = getObjectResource(params.optInOut);
            return optInOutRes.$update({customerId: params.customerId});
        };

        return service;
    }
    ]);



// WEBPACK FOOTER //
// ./js/website/services/OptInOut.js